import React, { useEffect} from 'react';
import { getFileName } from '../../../helpers/FileCaching';
//import MediaQuery from 'react-responsive';
// styles
import classes from './dynamicPagePromos.module.scss'
//import renderHTML from 'react-render-html';
import globalJSON from '../../../data/global.json'
import hubJSON from '../../../data/hub.json';

const dynamicPagePromosImages = require.context('../../../images/components/dynamicPagePromos', true, /.*\.(gif|png|jpe?g|svg)$/i);

const promoData = hubJSON.dynamicPagePromos.promos;
const data = hubJSON.dynamicPagePromos;
const heroData = hubJSON.dynamicPagePromos.heroSection;

function promoLoop(){
    
    function onClickSub(event){
        event.preventDefault()
		window.gtag('event', "promo article selection", {
			'event_category': globalJSON.tracking.ga_category,
			'event_label': "promo article clicked "+ event.currentTarget.href,
			'value':10
        });
        window.location = event.currentTarget.href
    }
    
    

    return(
       
            <div className={classes.dynamicPagePromos__promos}>
                {promoData.map((newpromo, index)  => {
                    return(
                        <div key={index}  className={classes.dynamicPagePromos__promos__promo_container}>
                              <a className={classes.dynamicPagePromos__promos__link} href={newpromo.promoURL} onClick={onClickSub}>
                            <div className={`${classes.dynamicPagePromos__promos__promo}`}>
                             
                                <div className={`${classes.dynamicPagePromos__promos__map_image}`} style={{backgroundImage: `url(${getFileName(dynamicPagePromosImages, newpromo.mapImage)})`}} title={newpromo.backgroundImageAlt}>
                                    <div className={`${classes.dynamicPagePromos__promos__map_overlay}`}></div>
                                    <div className={classes.dynamicPagePromos__promos__text_content}>
                                        <div className={classes.dynamicPagePromos__promos__city_and_state}>
                                            <h5 className={classes.dynamicPagePromos__promos__city}>{newpromo.city},</h5>
                                            <h5 className={classes.dynamicPagePromos__promos__state}>{newpromo.state}</h5>
                                        </div>
                                        <img className={classes.dynamicPagePromos__divider} src={getFileName(dynamicPagePromosImages, 'divider.svg')} />
                                        <h4 className={classes.dynamicPagePromos__promos__title} dangerouslySetInnerHTML={{__html:newpromo.title}} />
                                        <p className={classes.dynamicPagePromos__promos__cta_text_map}>{hubJSON.dynamicPagePromos.promoCtaText}</p>
                                    </div>
                                  
                                </div>        
                                <div className={`${classes.dynamicPagePromos__promos__city_image}`} style={{backgroundImage: `url(${getFileName(dynamicPagePromosImages, newpromo.backgroundImage)})`}} title={newpromo.mapImageAlt}>
                                    <div className={`${classes.dynamicPagePromos__promos__image_overlay}`}></div>
                                    <div className={classes.dynamicPagePromos__promos__text_content}>
                                        <div className={classes.dynamicPagePromos__promos__city_and_state}>
                                            <h5 className={classes.dynamicPagePromos__promos__city}>{newpromo.city}{(newpromo.state ? ',':"")}</h5>
                                            <h5 className={classes.dynamicPagePromos__promos__state}>{newpromo.state}</h5>
                                        </div>
                                        <img className={classes.dynamicPagePromos__divider} src={getFileName(dynamicPagePromosImages, 'divider.svg')} />
                                        <h4 className={classes.dynamicPagePromos__promos__title} dangerouslySetInnerHTML={{__html:newpromo.title}} />
                                        <p className={classes.dynamicPagePromos__promos__cta_text}>{hubJSON.dynamicPagePromos.promoCtaText}</p>
                                   </div>
                                </div>
                            </div>
                            </a>
                        </div>
                    );
                })}
            </div>

    )
}



function DynamicPagePromos({windowSize}){

    useEffect(() => {

    },[windowSize])

    function onClickHero(event){
        event.preventDefault()
		window.gtag('event', "promo article selection", {
			'event_category': globalJSON.tracking.ga_category,
			'event_label': "promo article clicked "+ event.currentTarget.href,
			'value':10
        });
        window.location = event.currentTarget.href;
	}

	return (
		<section id={"dynamicPagePromos"} className={classes.dynamicPagePromos}>
			<div className={classes.dynamicPagePromos__container}>
				<div className={classes.dynamicPagePromos__hero} style={{backgroundImage: `url(${getFileName(dynamicPagePromosImages, heroData.backgroundImage[windowSize])})`}}>
                    <div className={classes.dynamicPagePromos__mask_image}></div>
                    <div className={classes.dynamicPagePromos__hero__title_container} >
                            <div className={classes.dynamicPagePromos__promos__city_state}>
                                <a className={classes.dynamicPagePromos__hero__cta_link} href={heroData.cta.promoURL} onClick={onClickHero}>
                                    <h3 className={classes.dynamicPagePromos__hero__city}>{heroData.city}</h3>
                                </a>
                                <a className={classes.dynamicPagePromos__hero__cta_link} href={heroData.cta.promoURL} onClick={onClickHero}>
                                    <h1 className={classes.dynamicPagePromos__hero__state}>{heroData.state}</h1>
                                </a>	
                            </div>
                        
                        
                        <h3 className={classes.dynamicPagePromos__hero__title}>{heroData.title}</h3>
                        <a className={classes.dynamicPagePromos__hero__cta_link} href={heroData.cta.promoURL} onClick={onClickHero}>
                            <p className={classes.dynamicPagePromos__hero__cta_text}>{heroData.cta.buttonText}</p>
                        </a>	
                    </div>
                </div>
                {(
                    promoData ? 
                        <div className={classes.dynamicPagePromos__promos_content}>

                            {promoLoop()}
                            
                        </div>

                    : 
                        ""
                )}
			</div>
            {(
                data.backgroundImage ? 
                        <div className={classes.dynamicPagePromos__bg} style={{backgroundImage: `url(${getFileName(dynamicPagePromosImages, data.backgroundImage[windowSize])})`}} title={promoData.backgroundImageAlt}></div>
                    :
                        ""
            )}
            
		</section>
		
	)
}

export default DynamicPagePromos;